module.exports = __webpack_public_path__ + "img/Frame 1103hrp7.f0582e23.png";